import React, { useEffect, useState } from 'react'
import { FormikProps, withFormik, Form } from 'formik'
import Select from '../../select'
import { useTranslation } from 'react-i18next'
import { getToken } from '../../../helpers/utils'
import { AppDispatch, useAppDispatch } from '../../../redux/store'
import { getUserTags } from '../../../redux/reducers/urlReducer'

interface FilterProps {
  onSubmit: (values: FilterValues) => void
  children?: React.ReactNode
  tag?: string
}

interface FilterValues {
  tag: string
}

const InnerForm: React.FunctionComponent<
  FilterProps & FormikProps<FilterValues>
> = ({ handleChange, values, children }) => {
  const { t } = useTranslation()
  const [dataTags, setDataTags] = useState([])
  const dispatch: AppDispatch = useAppDispatch()

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    const token = getToken()
    try {
      const { payload } = await dispatch(getUserTags({ token: token }))
      if (payload.success) {
        const data = payload.data.map((item: string) => ({
          value: item,
          label: item,
        }))
        setDataTags(data)
      } else {
        console.error(`${t('ERROR')}`)
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }


  return (
    <>
      <Form>
        <div className='padding-bottom-1'>
          <Select
            optionSelect={true}
            optionSelectText={`${t('SELECT')}`}
            options={dataTags}
            id='tag'
            label={`${t('TAGS')}`}
            value={values.tag}
            classNameSelect='customized-select'
            disabled={false}
            onChange={handleChange}
          />
        </div>
        {children}
      </Form>
    </>
  )
}

const FormFilters = withFormik<FilterProps, FilterValues>({
  mapPropsToValues: (props: FilterProps) => {
    const initialValues: FilterValues = {
      tag: props.tag || '',
    }

    return { ...initialValues, ...props }
  },

  handleSubmit(values: FilterValues, { props }:any) {
    if (props.onSubmit) {

  
      props.onSubmit(values)
    }
  },
})(InnerForm)

export default FormFilters
